import React, { useEffect } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import InputAdornment from '@mui/material/InputAdornment';

import { palette } from '../../theme/palette';
import { svgStyles } from '../Common/Common.styled';
import { AutoCompleteTextField } from '../Autocomplete/Autocomplete.styled';
import SchoolsIcon from '../Icons/SchoolsIcon';

import useTeacherSchoolsFilter from './teacherschools-filter-hook';

interface Props {
  error?: boolean;
  className?: string;
  value?: SchoolValue | null | string;
  onChange?: (data: SchoolValue | null | string, district_id?: string | null ) => void;
  placeholder?: string;
  disabled?:boolean;
  readOnly?:boolean;
  idSelectOnly?: boolean;
  showStartAdorement?: boolean;
  onSchoolChange?: (school: SchoolValue | null | string) => void;
  updateLoader?: Function;
}

export type SchoolValue = {
  id: string,
  name: string
  district_id? : string
} | null | undefined;

const TeacherSchoolFilter = ({
  className,
  placeholder,
  onChange,
  value,
  disabled,
  readOnly = false,
  idSelectOnly = false,
  showStartAdorement = false,
  onSchoolChange,
  updateLoader,
}: Props) => {
  const {
    schools,
    loading,
  } = useTeacherSchoolsFilter();

  useEffect(() => {
    updateLoader?.(loading);
    if (!loading && schools.length > 0) {
      onSelectChange('', schools.find(school => idSelectOnly ? (school?.id === value) : school === value)!);
    }
  }, [loading]);

  const onSelectChange = (_: any, school: SchoolValue | null) => {
    onChange?.(idSelectOnly ? (school?.id ?? '') : school, school?.district_id);
    onSchoolChange?.(school);
  };

  const selectedValue: SchoolValue = idSelectOnly ? schools?.find((item) => item?.id === value) ?? null : value as SchoolValue;

  return (
    <Autocomplete
      className={className}
      options={schools || []}
      getOptionLabel={(option: any) => option?.name}
      isOptionEqualToValue={(option: any, selected: any) => option?.name === selected?.name}
      onChange={onSelectChange}
      value={selectedValue}
      disabled={disabled || loading}
      readOnly={readOnly}
      renderInput={(params) => (
        <AutoCompleteTextField
          {...params}
          placeholder={placeholder}
          InputProps={{
            ...params.InputProps,
            disableUnderline: true,
            style: { fontWeight: 800, fontSize: '16px' },
            ...(showStartAdorement ? {
              startAdornment: (
                <InputAdornment position="start">
                  <SchoolsIcon pathfill={palette.customBlue.primaryBlue} sx={{ ...svgStyles.icon }} />
                </InputAdornment>
              ),
            } : {}),
          }}
        />
      )}
    />
  );
};

export default TeacherSchoolFilter;
